import gql from 'graphql-tag'

export const MUTATION_REJECT_OFFER = gql`
  mutation RejectIndustryOffersSchedule($input: RejectIndustryOffersScheduleInput!) {
    rejectIndustryOffersSchedule(input: $input) {
      _id
    }
  }
`

export const QUERY_LIST_PROPOSAL_OFFER_SCHEDULES = gql`
  query ListOfferSchedulesCampaigns(
    $status: [String]
    $search: String
    $page: Int
    $pageSize: Int
    $format: [String]
    $sort: [String]
    $sortDirection: [SortDirection]
    $units: [String]
    $units_configuration: [UnitConfigurationInput]
    $franchise: Boolean
    $includeAuto: Boolean
    $industry: Boolean
    $offerIds: [String]
    $products: [String]
    $modality: [String]
    $personalized: Boolean
    $industryIds: [ID]
  ) {
    offerSchedules(
      status: $status
      search: $search
      page: $page
      pageSize: $pageSize
      format: $format
      sort: $sort
      sortDirection: $sortDirection
      units: $units
      units_configuration: $units_configuration
      franchise: $franchise
      include_auto: $includeAuto
      industry: $industry
      offerIds: $offerIds
      products: $products
      modality: $modality
      personalized: $personalized
      industryIds: $industryIds
    ) {
      offerSchedules {
        _id
        status
        name
        start_date
        end_date
        created_at
        updated_at
        products_count
        types
        industry {
          _id
          name
          proposal_deadline
          is_mercapromo
        }
        units {
          name
        }
        segments {
          name
        }
        offer_sales {
          ... on OfferSale {
            sku
            name
            ean
            eans
            price_1
            price_2
            price_base_industry
            rebate
            maximum_per_client
            image_url
            product {
              _id
              image
              sku
              ean
              eans
              name
            }
          }
          ... on OfferSalesGroup {
            _id
            name
            price_1
            price_2
            price_base_industry
            maximum_per_client
            rebate
            group_image_url
            offer_sales {
              name
              sku
              ean
            }
          }
        }
        percentage_offer_sales {
          ... on OfferSalePercentage {
            sku
            name
            ean
            eans
            percentage_discount
            maximum_per_client
            image_url
            product {
              _id
              image
              sku
              ean
              eans
              name
            }
          }
          ... on OfferSalesPercentageGroup {
            _id
            name
            percentage_discount
            maximum_per_client
            group_image_url
            percentage_offer_sales {
              name
              sku
              ean
            }
          }
        }
        takepay_offer_sales {
          ... on OfferSaleTakeAndPay {
            name
            sku
            ean
            eans
            take
            pay
            maximum_per_client
            image_url
            product {
              _id
              image
              sku
              ean
              eans
              name
            }
          }
          ... on OfferSalesTakeAndPayGroup {
            _id
            name
            take
            pay
            maximum_per_client
            group_image_url
            takepay_offer_sales {
              name
              sku
              ean
            }
          }
        }
        cashback_absolute_offer_sales {
          ... on OfferSaleCashbackAbsolute {
            name
            sku
            ean
            eans
            price
            cashback_absolute
            maximum_per_client
            minimum_per_client
            image_url
            product {
              _id
              image
              sku
              ean
              eans
              name
            }
          }
          ... on OfferSalesCashbackAbsoluteGroup {
            _id
            name
            price
            cashback_absolute
            maximum_per_client
            minimum_per_client
            group_image_url
            cashback_absolute_offer_sales {
              name
              sku
              ean
            }
          }
        }
        next_buy_cashback_offer_sales {
          ... on OfferSaleNextBuyCashback {
            sku
            ean
            eans
            name
            image_url
            max_coupons
            minimum_per_client
            cashback_absolute_discount
            price
            product {
              _id
              sku
              ean
              eans
              name
            }
          }
          ... on OfferSaleNextBuyCashbackGroup {
            _id
            name
            minimum_per_client
            cashback_absolute_discount
            max_coupons
            group_image_url
            next_buy_cashback_offer_sales {
              sku
              ean
            }
          }
        }
        dynamic_rule_offer_sales {
          trigger_products {
            sku
            ean
            eans
            name
            equivalent_quantity
            group_id
            group_name
            image_url
          }
          trigger_rules {
            maximum_per_client
          }
          benefits {
            type
            value
            voucher_provider
          }
        }
        cross_sell_offer_sales {
          trigger_products {
            sku
            ean
            eans
            name
            equivalent_quantity
            group_id
            group_name
            image_url
          }
          trigger_rules {
            maximum_per_client
            trigger_amount
          }
          target_products {
            sku
            ean
            eans
            name
            group_id
            image_url
          }
          target_rules {
            type
            discount
          }
        }
      }
      records
      page
    }
  }
`
